import {Component, OnInit} from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslationService } from 'src/app/core/base/services/translation.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

    menuMode = 'slim';

    layout = 'blue';

    theme = 'blue';

    ripple: boolean;

    colorScheme = 'light';

    constructor(private primengConfig: PrimeNGConfig, private translate: TranslationService) {
        this.translate.setLanguage(this.translate.getSelectedLanguage());
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.ripple = true;
    }
}
